'use client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { migrateAuthStorage } from '@/lib/auth-migration';
import { initializeTheme } from '@/lib/theme.store';
import { SessionManager } from '@/components/SessionManager';
import { SoundAlerts } from '@/components/SoundAlerts';
import { useNumberInputWheelGuard } from '@/lib/use-number-input-wheel-guard';

export function Providers({ children }: { children: React.ReactNode }) {
  // App-wide: stop mouse-wheel scrolling from silently changing focused number inputs
  // (e.g. a typed SL/target of 1 drifting to 0.99/0.98 as the form is scrolled).
  useNumberInputWheelGuard();
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
    },
  }));

  useEffect(() => {
    migrateAuthStorage();
    initializeTheme();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <SessionManager />
      <SoundAlerts />
      {children}
    </QueryClientProvider>
  );
}
